var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonnelCaption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1406 62.8327L41.1564 55.0333L41.1726 47.6484",
    fill: "#A9CF3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1462 62.8372L38.1406 62.8256L38.1726 47.6406L44.1781 47.6535L44.1462 62.8372Z",
    fill: "#A9CF3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9818 39.3125C27.7536 39.3125 17.0041 49.5819 17.1102 62.166C17.1117 62.1676 17.1127 62.1686 17.1143 62.1702H19.457H23.1096H29.6449V56.2285H24.194C26.7063 49.8306 33.2836 45.2542 40.9817 45.2542C48.6799 45.2542 55.2572 49.8306 57.7694 56.2285H52.3327V62.1702H58.8539H63.4211H64.849C64.8507 62.1686 64.8516 62.1676 64.8533 62.166C64.9596 49.5819 54.21 39.3125 40.9818 39.3125Z",
    fill: "#587E85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1745 45.2526C33.0227 45.2526 26.3906 38.9455 26.3906 31.1927C26.3906 23.44 33.0227 17.1328 41.1745 17.1328C49.3263 17.1328 55.9583 23.44 55.9583 31.1927C55.9583 38.9455 49.3262 45.2526 41.1745 45.2526ZM41.1745 23.0745C36.3341 23.0745 32.3962 26.7161 32.3962 31.1927C32.3962 35.6693 36.3341 39.3109 41.1745 39.3109C46.0149 39.3109 49.9528 35.6693 49.9528 31.1927C49.9528 26.7161 46.0149 23.0745 41.1745 23.0745Z",
    fill: "#A9CF3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8397 55.0555L40.9565 55.0398L33.4922 55.0234",
    fill: "#A9CF3D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8443 52.0862L48.8326 58.0279L33.4844 57.9964L33.4974 52.0547L48.8443 52.0862Z",
    fill: "#A9CF3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonnelCaption);
export default __webpack_public_path__ + "static/media/personnel-caption.6c5eebc961ee950aad646e26b23f94a4.svg";
export { ForwardRef as ReactComponent };